import { Link } from 'react-router-dom';
import { featuredContent } from '@/mocks/homeData';

export default function FeaturedSection() {
  return (
    <section className="w-full px-4 md:px-6 lg:px-10 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8 md:mb-12">
          <div>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900 mb-2">
              热门<span className="text-primary-500">推荐</span>
            </h2>
            <p className="text-sm text-foreground-500">本周最受欢迎的内容，不容错过</p>
          </div>
          <Link
            to="/category/tv-series"
            className="hidden sm:flex items-center gap-1 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {featuredContent.map((item) => (
            <Link
              key={item.id}
              to={`/article/${item.id}`}
              className="group bg-background-50 rounded-xl overflow-hidden cursor-pointer transition-transform duration-300 hover:-translate-y-1"
            >
              <div className="relative h-48 md:h-52 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-background-50/90 backdrop-blur-sm text-foreground-800 text-xs font-medium rounded-md">
                    {item.category}
                  </span>
                </div>
                <div className="absolute top-3 right-3">
                  <span className="px-2 py-0.5 bg-primary-500 text-background-50 text-xs font-bold rounded-md">
                    {item.rating}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 mb-1.5 line-clamp-1 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed">{item.description}</p>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-8 sm:hidden">
          <Link
            to="/category/tv-series"
            className="inline-flex items-center gap-1 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}